import usePlacesAutocomplete, { getGeocode } from 'use-places-autocomplete';
import AutoComplete from 'antd/lib/auto-complete/AutoComplete';

interface PlacesAutocompleteProps {
    value?: string;
    onSelect: (geocoderResult: google.maps.GeocoderResult | null) => void;
}

export const PlacesAutocomplete = (props: PlacesAutocompleteProps) => {
    const addressValue = typeof props.value === 'string' ? props.value : undefined;
    const { ready, value, suggestions, setValue, clearSuggestions } = usePlacesAutocomplete({
        defaultValue: addressValue,
        requestOptions: {
            types: ['establishment', 'geocode'],
        },
        debounce: 300,
    });

    const handleInput = (value: string) => {
        setValue(value);
    };

    const handleSelect = async (suggestion: google.maps.places.AutocompletePrediction) => {
        const { description } = suggestion;

        // When the user selects a place, we can replace the keyword without request data from API
        // by setting the second parameter to "false"
        setValue(description, false);
        clearSuggestions();

        const geoCodeResults = await getGeocode({ address: description });
        props.onSelect(geoCodeResults?.[0] || null);
    };

    const onSelect = (indexStr: string) => {
        const suggestion = suggestions.data[Number(indexStr)];
        if (suggestion) {
            handleSelect(suggestion);
        }
    };

    const options = suggestions.data.map((suggestion, index) => {
        const {
            structured_formatting: { main_text, secondary_text },
        } = suggestion;

        return {
            label: (
                <div>
                    {main_text}; {secondary_text}
                </div>
            ),
            value: String(index),
        };
    });

    return (
        <AutoComplete
            disabled={!ready}
            style={{ width: '100%' }}
            onSearch={handleInput}
            onSelect={onSelect}
            options={options}
            value={value}
            placeholder="Address"
        />
    );
};
